import { Getters } from 'vuex-smart-module';
import ClientDetailState from './state';

export default class ClientDetailStateGetters extends Getters<ClientDetailState> {}
